import { z } from 'zod';

import { VerdictSchema } from './enums';
import { TickerSchema } from './primitives';

const NonNegIntSchema = z.number().int().nonnegative();
/** n_analysts > 0 (plan DB CHECK); verdict math divides by nA. */
const PositiveIntSchema = z.number().int().positive();

/**
 * F15 verdict thresholds: BUY if buy/nA > 0.55, else HOLD if > 0.35, else REDUCE.
 * Lives beside the counts the ratio is taken over (plan §3.2).
 */
export const VERDICT_THRESHOLDS = {
  buy: 0.55,
  hold: 0.35,
} as const;

/**
 * Analyst consensus (F15). Live v1 has no licensed provider — profiles carry
 * `consensus: null` while synthetic keeps seeded values (plan §6.5a).
 * Sum buy+hold+sell===nA is enforced by DB/core, not this structural wire schema.
 */
export const AnalystConsensusSchema = z.object({
  ticker: TickerSchema,
  nA: PositiveIntSchema,
  buy: NonNegIntSchema,
  hold: NonNegIntSchema,
  sell: NonNegIntSchema,
  /** Nullable: plan §6.3 `price_target NUMERIC(18,6)` has no NOT NULL, and an
      unpublished target is not a target of zero (R2b). */
  target: z.number().nullable(),
  verdict: VerdictSchema,
});
export type AnalystConsensus = z.infer<typeof AnalystConsensusSchema>;
